export class WishlistStorage {
  constructor() {
    this.storage = window.localStorage
    this.WISHLIST_KEY = 'customer-wishlist-SS'
    this.init()
  }

  init() {
    /** Check local storage to see if the customer's wishlist exists */
    const items = this.storage.getItem(this.WISHLIST_KEY)

    /** If not return an empty array */
    if (!items) {
      this.items = []
      return
    }

    this.items = this.parseItems('json', items)
  }

  getItems() {
    return this.items
  }

  setItem(item) {
    /** update local instance */
    this.items.push(item)

    /** update data in local storage */
    this._updateLocalStorage()
  }

  hasItem(item) {
    return !!this.items.find((i) => i === item)
  }

  removeItem(item) {
    /** filter out item and set the new list to itself  */
    this.items = this.items.filter((i) => i !== item)

    /** update data in local storage */
    this._updateLocalStorage()
  }

  parseItems(action = 'string' | 'json', items) {
    switch (action) {
      case 'string': {
        return JSON.stringify(items)
      }
      case 'json': {
        return JSON.parse(items)
      }
      default: {
        throw new Error(`Not a valid action key given, ${action}`)
      }
    }
  }

  _updateLocalStorage() {
    /** update data in local storage */
    const parsedData = this.parseItems('string', this.items)
    this.storage.setItem(this.WISHLIST_KEY, parsedData)
  }

  getProductIds() {
    const productIds = this.getItems().reduce((acc, item) => {
      const [productId, _] = item.split(':')
      if (!productId) {
        return acc
      }
      acc[productId] = 1
      return acc
    }, {})

    return Object.keys(productIds)
  }
}

window.wishlistStorage = new WishlistStorage()
